/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// $(function(){
//   $('#shopify-product-reviews script[type="application/ld+json"]').remove();
//   setTimeout(function(){
//     $('#shopify-product-reviews script[type="application/ld+json"]').remove();
//   }, 10000);
//   setTimeout(function(){
//     $('#shopify-product-reviews script[type="application/ld+json"]').remove();
//   }, 2000);
//   setTimeout(function(){
//     $('#shopify-product-reviews script[type="application/ld+json"]').remove();
//   }, 5000);
//   setTimeout(function(){
//     $('#shopify-product-reviews script[type="application/ld+json"]').remove();
//   }, 7000);
// });

// var country_code = 'DE';// default

var targetNode = document.getElementById('banner-wrapper');
var observer = new MutationObserver(function(){
    if (targetNode.style.display != 'none'){
        document.documentElement.style.overflowY = 'hidden';
    } else {
      document.documentElement.style.overflowY = 'scroll';
    }
});
observer.observe(targetNode, { attributes: true, childList: true });

  
  jQuery(document).ready(function($) {

    var currentAjaxRequest = null;

    var searchForms = $('form[action="/search"]').css('position','relative').each(function() {

      var input = $(this).find('input[name="q"]');
      var offSet = input.position().top + input.innerHeight();

      $('<ul class="box-results"></ul>').css( { 'position': 'absolute', 'width': '80%', 'left': '10%', 'right': '10%', 'text-align': 'left', 'top': offSet } ).appendTo($(this)).hide();

      input.attr('autocomplete', 'off').bind('keyup change', function() {

        var term = $(this).val();
        var form = $(this).closest('form');
        var searchURL = '/search?type=product&q=' + term;
        var resultsList = form.find('.box-results');

        if (term.length >= 3 && term != $(this).attr('data-old-term')) {
          
          $(this).attr('data-old-term', term);
          
          if (currentAjaxRequest != null) currentAjaxRequest.abort();
          
          currentAjaxRequest = $.getJSON(searchURL + '&view=json', function(data) {
            resultsList.empty();

            if(data.results_count == 0) {
              resultsList.hide();
            } else {
              $.each(data.results, function(index, item) {
                var link = $('<a></a>').attr('href', item.url);

                link.append('<span class="thumbnail"><img src="' + item.thumbnail + '" /></span>');
                link.append('<span class="title_name">' + item.title + '</span>');
                link.wrap('<li></li>');

                resultsList.append(link.parent());
              });

              if(data.results_count > 5) {
                resultsList.append('<li class="a-center"><span class="btn btn-results"><a href="' + searchURL + '"> All Results (' + data.results_count + ')</a></span></li>');
              }

              resultsList.fadeIn(200);
            }
          });
        }
      });
      
    });

    $('body').bind('click', function(){
      $('.box-results').hide();
    });
    
    
    // PRICE WITH TAX
//     var ipinfo = $.get("https://ipinfo.io", function(response) {
//       country_code = response.country;
//     }, "jsonp");

  });